import React, { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@material-ui/core/Button";
import "./Services.scss";

import EventNoteIcon from "@material-ui/icons/EventNote";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";

import PersonIcon from "@material-ui/icons/Person";
import StarHalfIcon from '@material-ui/icons/StarHalf';
import { NavLink } from "react-router-dom";

// snakBar for showing distance
import SnackBar from "./GeneralComponents/SnackBar";

export const Services = () => {
  const navigate = useNavigate();
  // check token if expire redirect to login page
  useLayoutEffect(() => {
    if (localStorage.getItem("token") == null) {
      navigate("/login");
    }
  }, []);

  setTimeout(() => {
    localStorage.removeItem("loginMessage");
  }, 3000);

  return (
    <div className="services-items">
      <p className="name-of-user-top-of-pages" dir="rtl" style={{ margin: 10 }}>
        {localStorage.getItem("name") ? (
          <span>{`${localStorage.getItem("name")} عزیز: `}</span>
        ) : (
          `لطفا ابتدا وارد شو و بعد`
        )}
        <br></br>
        سرویس مورد نظرت رو انتخاب کن:{" "}
      </p>
      <div className="service-item-container">
        <Button className="service-item">
          <NavLink to="/projects">
            <PlaylistAddCheckIcon
              className="service-item-icon"
              style={{ fontSize: 40 }}
            />
            <p>لیست پروژه ها</p>
          </NavLink>
        </Button>
        <Button className="service-item">
          <NavLink to="/leave">
            <EventNoteIcon
              className="service-item-icon"
              style={{ fontSize: 40 }}
            />
            <p>درخواست مرخصی</p>
          </NavLink>
        </Button>
        <Button className="service-item">
          <NavLink to="/profile">
            <PersonIcon
              className="service-item-icon"
              style={{ fontSize: 40 }}
            />
            <p>پروفایل من</p>
          </NavLink>
        </Button>
        <Button className="service-item">
          <NavLink to="/user-rate">
            <StarHalfIcon
              className="service-item-icon"
              style={{ fontSize: 40 }}
            />
            <p>امتیازات شما</p>
          </NavLink>
        </Button>
      </div>

      {localStorage.getItem("loginMessage") && (
        <SnackBar
          message={`${localStorage.getItem(
            "name"
          )} عزیز شما با موفقیت وارد شدید `}
          variant="success"
        />
      )}
    </div>
  );
};
export default Services;
